import {SPEED_ANIMATION} from "../consts";

export const cancelSwipe = function (gallery) {
    if (gallery.attr('animation')) {
        return false;
    }

    gallery.find('.material-gallery-images-container').animate({left: gallery.attr('startPosition')}, SPEED_ANIMATION);
};
